<span (click)="onClick($event)">{{params.value}}</span>